/*
 * Wholesale Customer Portal.
 *
 * Filtering is powered by Shopify's native Search & Discovery facets. Facets +
 * grid are rendered server-side into [data-wh-inner]; this script intercepts
 * facet links, pagination, the price form and the search box, re-fetches the
 * same context with ?view=wholesale (collection.wholesale / search.wholesale,
 * both {% layout none %}) and swaps the inner HTML.
 *
 * Supports multiple independent grids on one page. All interaction is handled
 * with GLOBAL event delegation on document, so it is robust to init timing and
 * to the page content being re-rendered by page-builder apps (each grid keeps
 * its own loader on the element). Only the first grid syncs the URL.
 */
(function () {
  'use strict';

  function withView(url) {
    if (/[?&]view=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'view=wholesale';
  }

  // Per-grid loader (created lazily, stored on the element).
  function loaderFor(root) {
    if (root.__whLoad) return root.__whLoad;
    var portalPath = location.pathname;
    var fetchCtl = null;
    function load(url, push) {
      var inner = root.querySelector('[data-wh-inner]');
      if (!inner) return;
      if (fetchCtl) fetchCtl.abort();
      fetchCtl = new AbortController();
      inner.setAttribute('aria-busy', 'true');
      return fetch(withView(url), {
        signal: fetchCtl.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          inner.innerHTML = html.trim();
          inner.setAttribute('aria-busy', 'false');
          if (root.hasAttribute('data-wh-primary') && push !== false && window.history && history.replaceState) {
            try { var _u = new URL(url, location.origin); _u.searchParams.delete('view'); history.replaceState({}, '', portalPath + (_u.search || '')); } catch (e) {}
          }
          if (window.AOS && AOS.refreshHard) { try { AOS.refreshHard(); } catch (e) {} }
        })
        .catch(function (e) { if (e.name !== 'AbortError') inner.setAttribute('aria-busy', 'false'); });
    }
    root.__whLoad = load;
    return load;
  }

  function debounce(fn, wait) {
    var t;
    return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }

  // Per-grid debounced search.
  function searcherFor(root) {
    if (root.__whSearch) return root.__whSearch;
    root.__whSearch = debounce(function () {
      var input = root.querySelector('.wholesale-search');
      var clearBtn = root.querySelector('.wholesale-search__clear');
      var searchUrl = root.getAttribute('data-search-url') || '/search';
      var collUrl = root.getAttribute('data-collection-url') || '/collections/all';
      var q = input ? input.value.trim() : '';
      if (clearBtn) clearBtn.hidden = q.length === 0;
      if (q.length === 0) { loaderFor(root)(collUrl); return; }
      loaderFor(root)(searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last');
    }, 280);
    return root.__whSearch;
  }

  // ---- Global delegated handlers ----
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('wholesale-search')) return;
    var root = t.closest('[data-wh-collection]');
    if (root) searcherFor(root)();
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var clr = e.target.closest('.wholesale-search__clear');
    if (clr) {
      var root = clr.closest('[data-wh-collection]');
      if (!root) return;
      var input = root.querySelector('.wholesale-search');
      if (input) input.value = '';
      clr.hidden = true;
      loaderFor(root)(root.getAttribute('data-collection-url') || '/collections/all');
      if (input) input.focus();
      return;
    }
    var link = e.target.closest('a.js-wh-facet, .wholesale-pagination a');
    if (link) {
      var root2 = link.closest('[data-wh-collection]');
      if (!root2) return;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      e.preventDefault();
      loaderFor(root2)(href);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.js-wh-price');
    if (!form) return;
    var root = form.closest('[data-wh-collection]');
    if (!root) return;
    e.preventDefault();
    var base = form.getAttribute('data-url') || root.getAttribute('data-collection-url') || '/collections/all';
    var params = [];
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.name && el.value !== '') { params.push(encodeURIComponent(el.name) + '=' + encodeURIComponent(el.value)); }
    });
    loaderFor(root)(base + (params.length ? '?' + params.join('&') : ''));
  });

  // ---- Initial load per grid (idempotent; re-run to catch late grids) ----
  function initAll() {
    var roots = document.querySelectorAll('[data-wh-collection]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (i === 0 && !root.hasAttribute('data-wh-primary')) root.setAttribute('data-wh-primary', '');
      if (root.__whInitLoaded) continue;
      if (!root.querySelector('[data-wh-inner]')) continue;
      root.__whInitLoaded = true;
      var collUrl = root.getAttribute('data-collection-url') || '/collections/all';
      var q = (i === 0) ? (location.search || '') : '';
      loaderFor(root)(collUrl + q, false);
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); }
  else { initAll(); }
  window.addEventListener('load', initAll);
  setTimeout(initAll, 1200);
})();
